var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSidebarMidscreenBitalogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu General")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ipad",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BITACore---Ipad---04",
    transform: "translate(-25.000000, -23.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Menu---Half"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0",
    transform: "translate(0.409264, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0.027093, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-General",
    transform: "translate(25.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.058713, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.30653938e-14,71.830454 L35.8222679,0 L37.1633574,0 L72.9853765,71.830454 L58.4269664,71.830454 L52.9673138,60.5302088 C47.3857439,48.2227179 41.8041741,35.9149718 36.2226043,23.6074809 C29.0013721,39.6818052 21.7801399,55.7558744 14.5591565,71.830454 L-2.30653938e-14,71.830454 Z",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "24.3284588 62.5238878 48.6569177 62.5620084 36.3254176 37.8461532"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebarMidscreenBitalogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidebar-midscreen-bitalogo.0fa9af73.svg";
export { ForwardRef as ReactComponent };